(function () {
  if (window.LuminatePdpRelatedContent) return;
  var loaded = new WeakSet();
  async function refresh() {
    var roots = document.querySelectorAll('[data-pdp-related-content]');
    for (var i = 0; i < roots.length; i++) {
      var root = roots[i];
      var section = root.querySelector('[data-pdp-native-related]');
      if (!section || !section.dataset.url || loaded.has(section)) continue;
      loaded.add(section);
      try {
        var response = await fetch(section.dataset.url, { credentials: 'same-origin' });
        if (!response.ok) continue;
        var html = new DOMParser().parseFromString(await response.text(), 'text/html');
        if (!section.isConnected) continue;
        var destination = section.querySelector('[data-pdp-native-cards]');
        if (!destination) continue;
        var seen = new Set([root.dataset.sourceProduct, '7695404859457']);
        root.querySelectorAll('[data-pdp-related-product]').forEach(function (card) { seen.add(card.dataset.pdpRelatedProduct); });
        var candidates = html.querySelectorAll('[data-pdp-native-results] [data-pdp-related-product]');
        for (var j = 0; j < candidates.length && destination.children.length < 4; j++) {
          var candidate = candidates[j], id = candidate.dataset.pdpRelatedProduct;
          if (!id || seen.has(id)) continue;
          seen.add(id);
          destination.appendChild(candidate);
        }
        destination.dataset.count = String(destination.children.length);
        section.hidden = destination.children.length === 0;
      } catch (error) {}
    }
  }
  window.LuminatePdpRelatedContent = { refresh: refresh };
  document.addEventListener('shopify:section:load', refresh);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
})();
